import OnboardPMForm from "@/rmpm/components/onboard-pm-form"
import RMForm from "@/rmpm/components/onboard-rm-form"
import { PMTruck, RMTruck } from "@/store/rmpm"

export interface AddTruckFormProps {
  rmTrucks: RMTruck[]
  pmTrucks: PMTruck[]
  defaultRmTrucks: RMTruck[]
  defaultPmTrucks: PMTruck[]

  onChangePmTrucks?: (trucks: PMTruck[]) => void
  onChangeRmTrucks?: (trucks: RMTruck[]) => void
}

export default function AddTruckForm({
  pmTrucks,
  rmTrucks,
  defaultRmTrucks,
  defaultPmTrucks,
  onChangePmTrucks,
  onChangeRmTrucks,
}: AddTruckFormProps) {
  function handledChangeRmTrucks(trucks: RMTruck[]) {
    if (onChangeRmTrucks) {
      onChangeRmTrucks(trucks)
    }
  }

  function handledChangePmTrucks(trucks: PMTruck[]) {
    if (onChangePmTrucks) {
      onChangePmTrucks(trucks)
    }
  }

  return (
    <form>
      <RMForm
        trucks={rmTrucks}
        defaultValue={defaultRmTrucks}
        onChange={handledChangeRmTrucks}
      />

      <hr className="w-full h-2.5 bg-band-fill" />

      <OnboardPMForm
        trucks={pmTrucks}
        defaultValue={defaultPmTrucks}
        onChange={handledChangePmTrucks}
      />
    </form>
  )
}
